import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';

import TowerIcon from '@ott/icon-tower';
import { l10n, l10nhtml } from '@ott/l10n';

import styles from './Fallback.scss';

const Fallback = ({ className }) => {
  return (
    <div className={cls(styles.container, className)}>
      <div className={styles.icon}>
        <TowerIcon />
      </div>
      <div className={styles.title}>{l10n('errorFallback.title')}</div>
      <div className={styles.description}>{l10nhtml('errorFallback.description')}</div>
    </div>
  );
};

Fallback.propTypes = {
  className: PropTypes.string,
};

export default Fallback;
